import isArrayHasItems from "web/utils/data/validator/array/isArrayHasItems";

import type { BankResetItems } from "web/types/Banks";
import type { IPaymentSettingsItem } from "web/types/Payment";
import type { Nullable } from "web/types/Utils";

import { BANK_PAYMENTS_TYPE } from "web/utils/system/redux/separateFinancingSourcesPerProduct/consts";
import type { TBankCountsForPaymentSortContext } from "web/utils/system/redux/separateFinancingSourcesPerProduct/getBankCountForPaymentSortContext";
import sortPaymentSettings from "web/utils/system/redux/separateFinancingSourcesPerProduct/sortPaymentSettings";
import type { ProductToSeparateWithPaymentSettings } from "web/utils/system/redux/separateFinancingSourcesPerProduct/types";

import type { IProductPointBankItem } from "./getProductPointBanksEligibility";

const EMPTY_BANK_COUNTS: TBankCountsForPaymentSortContext = {
  productCountByBankId: {},
  banksSub10Products: new Set<string>(),
};

export interface ISortProductPointBanksOptions {
  paymentSuggestion?: Nullable<string>;
  bankResets?: BankResetItems;
  bankCountsForPaymentSortContext?: TBankCountsForPaymentSortContext;
}

const sortProductPointBanks = (
  banks: IProductPointBankItem[],
  {
    paymentSuggestion = null,
    bankResets = [],
    bankCountsForPaymentSortContext = EMPTY_BANK_COUNTS,
  }: ISortProductPointBanksOptions = {}
): IProductPointBankItem[] => {
  if (!isArrayHasItems(banks) || banks.length < 2) {
    return banks;
  }

  const paymentSettings = banks.map(
    (bank) =>
      ({
        active: true,
        code: bank.points_bank_id,
        type: BANK_PAYMENTS_TYPE,
      }) as IPaymentSettingsItem
  );

  const current = {
    sku: "",
    id: "",
    payment_settings: paymentSettings,
    paymentSettings,
    payment_suggestion: paymentSuggestion,
    mb_payment_amount: 0,
  } as ProductToSeparateWithPaymentSettings;

  const sortedPaymentSettings = sortPaymentSettings({
    paymentSettings: [...paymentSettings],
    sourceArray: [current],
    current,
    bankCountsForPaymentSortContext,
    bankResets: bankResets ?? [],
  });

  const banksById = new Map(
    banks.map((bank) => [bank.points_bank_id, bank] as const)
  );

  return sortedPaymentSettings
    .map((payment) => banksById.get(payment.code))
    .filter((bank): bank is IProductPointBankItem => Boolean(bank));
};

export default sortProductPointBanks;
